interface DoubleClickOptions<T extends (...args: any[]) => void> {
    onSingleClick?: T;
    delay?: number;
}

export function useDoubleClick<T extends (...args: any[]) => void>(
    callback: T,
    options?: DoubleClickOptions<T> | number
) {
    const delay = typeof options === 'number' ? options : (options?.delay ?? 250);
    const onSingleClick = typeof options === 'object' ? options?.onSingleClick : undefined;
    let clickTimer: ReturnType<typeof setTimeout> | null = null;

    const onClick = (...args: Parameters<T>) => {
        if (clickTimer) {
            clearTimeout(clickTimer);
            clickTimer = null;
            callback(...args);
            return;
        }
        clickTimer = setTimeout(() => {
            clickTimer = null;
            if (onSingleClick) {
                onSingleClick(...args);
            }
        }, delay);
    };

    return { onClick };
}
